import { render } from "./TabelaInput.vue?vue&type=template&id=62a7404b&scoped=true&ts=true"
import script from "./TabelaInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./TabelaInput.vue?vue&type=script&setup=true&lang=ts"

import "./TabelaInput.vue?vue&type=style&index=0&id=62a7404b&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62a7404b"],['__file',"src/components/Tabela/TabelaInput.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "62a7404b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('62a7404b', __exports__)) {
    api.reload('62a7404b', __exports__)
  }
  
  module.hot.accept("./TabelaInput.vue?vue&type=template&id=62a7404b&scoped=true&ts=true", () => {
    api.rerender('62a7404b', render)
  })

}


export default __exports__